import { render, staticRenderFns } from "./MioTrainerTeams.vue?vue&type=template&id=4a3a73e7&"
import script from "./MioTrainerTeams.vue?vue&type=script&lang=js&"
export * from "./MioTrainerTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports